import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { CreateSecurityGroupRequest } from '../../../../api/types/settings/permissions/security-group-entity';

export const createSecurityGroupOperation = async (
  payload: CreateSecurityGroupRequest,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  const name = payload.name.trim();
  const description = payload.description?.trim() ?? '';

  if (!name) {
    toast.warn('יש להזין שם קבוצה');
    return;
  }
  if (name.length > 128) {
    toast.warn('שם הקבוצה יכול להכיל עד 128 תווים');
    return;
  }

  try {
    setLoading(true);
    const res = await appApi.createSecurityGroup({
      name,
      description: description === '' ? null : description,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    toast.success('קבוצת הרשאות נוספה בהצלחה');
    onSuccess();
  } catch (error) {
    console.error('createSecurityGroupOperation failed:', error);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
